export const ANALYSIS_ID = 'analysis_id';
export const TICKET = 'usercenter_t';
export const OPENID = 'usercenter_openId_pay';
export const WX_OPEN_ID = 'WX_OPEN_ID';
export const WX_CODE = 'WX_CODE';
export const IOS_PAY_PARAM_CACHE = 'IOS_PAY_PARAM_CACHE';


export const SIGN_STAT = 'SIGN_STAT';

export const ACT_SOURCE = 'osh5_source';
export const ACT_TICKET = 'osh5_ticket';
export const ACT_ORDERID = 'osh5_orderId';



// WEBPACK FOOTER //
// ./src/constant/CookieKeys.js